import React from "react";
import ConnectedOnePayPayPal from "./ConnectedOnePayPayPal";

/**
 * @returns {React.ReactElement}
 */
const ConnectedOnePayPaymentMethods = () => (
    <div className="col col--12 -text--center">
        <ConnectedOnePayPayPal />
        <div className="-text--center">
            I am going to be the Connected OnePay component wrapper!
        </div>
    </div>
);

export default ConnectedOnePayPaymentMethods;
